import DiagramType from "../../../../../logic/components/Diagram/DiagramType";
import { Tag } from "../../../core/render/logic/Markdoc";
import { parseScale } from "./getAttrs";
import parseDiagramInfo from "./parseDiagramInfo";

const getDiagramTagByFence = (info: string, content: string) => {
	const { name, attrs } = parseDiagramInfo(info);
	const scale = parseScale(attrs.scale);

	return new Tag(DiagramType[name], {
		content,
		...(attrs.title ? { title: attrs.title } : {}),
		...(attrs.float ? { float: attrs.float } : {}),
		...(scale ? { scale } : {}),
	});
};

export default getDiagramTagByFence;
